import styled from 'styled-components';
import ErrorTemplate from '../../../../Errors/ErrorTemplate';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  padding: 16px;
`;

const LoadingWrapper = styled.div`
  margin: 15px;
`;

const ErrorTemplateStyled = styled(ErrorTemplate)`
  .customError {
    padding-bottom: 0px;
  }
`;

export { ContentContainer, LoadingWrapper, ErrorTemplateStyled };
